/**
 * mdzo-collection-autoload.js v2 (2026-09-18) — Kategorie- und Suchseite: "Mehr laden" bis zu dreimal automatisch;
 * seit v2 ausserdem: Filter-Seitenleiste standardmaessig eingeklappt.
 *
 * NEU v2 (2026-09-18): Retail Cloud Connect merkt die Wahl "Filter verfeinern" in localStorage unter
 * 'rcc-search:left-toggle-filters:<Block-ID>' ('false' = zu). Gibt es den Merker noch nicht, wird er hier auf 'false'
 * gesetzt — die App startet dann eingeklappt. Wer die Filter oeffnet, behaelt sie offen (der Merker existiert dann).
 *
 * Die Produktliste kommt von Retail Cloud Connect (section.rcc-search__loadmore mit
 * button.rcc-search__loadmore__button, gemessen 17.09.: ein Klick laedt 36 bzw. 48 Karten nach, ohne Seitenwechsel).
 * Dieses Skript klickt den vorhandenen Knopf, sobald er in den Blick kommt — hoechstens MAX_AUTO mal je Ansicht.
 * Danach bleibt der Knopf stehen und der Kunde entscheidet selbst; so bleibt der Fuss der Seite erreichbar.
 *
 * Bewusst so:
 *  - Kein eigener Netzaufruf, keine eigene Darstellung: geklickt wird genau der Knopf der App.
 *  - Ein Klick nach dem anderen (laeuft-Sperre bis die Kartenzahl steigt, hoechstens WARTE_MAX_MS).
 *  - Zaehler wird zurueckgesetzt, wenn sich die URL aendert (Filter, Sortierung, Suchbegriff).
 *  - Die App rendert spaet und baut den Abschnitt bei Filterwechseln neu: ein MutationObserver haengt den
 *    IntersectionObserver dann erneut an (gedrosselt ueber requestAnimationFrame).
 *  - Ohne IntersectionObserver (sehr alte Browser) passiert nichts; der Knopf funktioniert wie bisher.
 */
(function () {
  'use strict';

  var MAX_AUTO = 3;
  var SEKTION = '.rcc-search__loadmore';
  var KNOPF = '.rcc-search__loadmore__button';
  var KARTE = '.rcc-search__product';
  var VORLAUF = '100px';      // kurz bevor der Knopf im Bild ist (Nutzer 17.09.: nicht 300)
  var WARTE_MAX_MS = 8000;    // Sperre spaetestens danach loesen, falls nichts nachkommt
  var TAKT_MS = 250;

  // ---- v2: Filter-Seitenleiste standardmaessig zu (nur wenn der Besucher noch nicht selbst gewaehlt hat) ----
  try {
    var FILTER_MERKER = 'rcc-search:left-toggle-filters:';
    var bloecke = document.querySelectorAll('[id^="shopify-block-"][id*="retail_cloud_connect_app_"]');
    for (var b = 0; b < bloecke.length; b++) {
      var schluessel = FILTER_MERKER + bloecke[b].id.slice('shopify-block-'.length);
      if (window.localStorage.getItem(schluessel) === null) window.localStorage.setItem(schluessel, 'false');
    }
  } catch (e) {}

  if (typeof IntersectionObserver !== 'function') return;

  var geklickt = 0;
  var laeuft = false;
  var beobachtet = null;
  var letzteUrl = location.pathname + location.search;
  var beobachter = new IntersectionObserver(function (eintraege) {
    for (var i = 0; i < eintraege.length; i++) if (eintraege[i].isIntersecting) klicken();
  }, { rootMargin: VORLAUF });

  function anzahl() { return document.querySelectorAll(KARTE).length; }
  function sektion() { return document.querySelector(SEKTION); }
  function knopf() { var s = sektion(); return s ? s.querySelector(KNOPF) : null; }

  function klicken() {
    if (laeuft || geklickt >= MAX_AUTO) return;
    var k = knopf();
    if (!k || k.disabled || k.offsetParent === null) return;
    var vorher = anzahl();
    laeuft = true;
    geklickt += 1;
    try { k.click(); } catch (e) { laeuft = false; return; }
    var start = Date.now();
    (function warten() {
      if (anzahl() > vorher || Date.now() - start > WARTE_MAX_MS) { laeuft = false; return; }
      setTimeout(warten, TAKT_MS);
    })();
  }

  function anhaengen() {
    var s = sektion();
    if (s === beobachtet) return;
    if (beobachtet) beobachter.unobserve(beobachtet);
    beobachtet = s;
    if (s) beobachter.observe(s);
  }

  var geplant = false;
  function bald() {
    if (geplant) return;
    geplant = true;
    requestAnimationFrame(function () {
      geplant = false;
      var url = location.pathname + location.search;
      if (url !== letzteUrl) { letzteUrl = url; geklickt = 0; }   // Filter/Sortierung/Suche: neu zaehlen
      anhaengen();
    });
  }

  new MutationObserver(bald).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('popstate', bald);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bald); else bald();
})();
